import { render } from "./ListeOrganisationsPage.vue?vue&type=template&id=b9aa728e&ts=true"
import script from "./ListeOrganisationsPage.vue?vue&type=script&lang=ts"
export * from "./ListeOrganisationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__